export interface ScoreEntry {
  levelId: number;
  score: number;
  at: number;
}
export interface ScoreService {
  submit(e: ScoreEntry): Promise<void>;
  best(levelId: number): Promise<number>;
  all(): Promise<ScoreEntry[]>;
}
interface StorageLike {
  getItem(k: string): string | null;
  setItem(k: string, v: string): void;
  removeItem(k: string): void;
}

export class LocalScoreService implements ScoreService {
  private readonly KEY = 'hambi.scores';
  constructor(private readonly storage: StorageLike) {}
  private read(): ScoreEntry[] {
    const raw = this.storage.getItem(this.KEY);
    return raw ? (JSON.parse(raw) as ScoreEntry[]) : [];
  }
  async submit(e: ScoreEntry): Promise<void> {
    const all = this.read();
    all.push(e);
    this.storage.setItem(this.KEY, JSON.stringify(all));
  }
  async best(levelId: number): Promise<number> {
    return this.read()
      .filter((e) => e.levelId === levelId)
      .reduce((m, e) => Math.max(m, e.score), 0);
  }
  async all(): Promise<ScoreEntry[]> {
    return this.read();
  }
  /** Remove all stored scores. */
  clear(): void {
    this.storage.removeItem(this.KEY);
  }
}
